import React from 'react';
import MathJax from '../../components/react-mathjax-preview'
import LoadingSpinner from '../../components/LoadingSpinner'
import {Cell,Grid} from 'react-md'
import {replaceImageWidth, createVideoLinkIframe} from '../../common/functions'

//CSS Import
import '../../css/QuestionWithImage.css'
import MathParserUtil from '../../lib/math-parser';


const checkBoxOneColumnSize = 1;
const checkBoxValueOneColumnSize = 11;

const checkBoxTwoColumnSize = 1;
const checkBoxValueTwoColumnSize = 5;

const AnswerTypeCheckbox = function (props) {

    let correctAnswerIds        =   [];

    let handleClick = function(id,index) {
        if(props.onAnswerChoice !== undefined)
            props.onAnswerChoice(id,index);


      }

    let handleClickContent = function(index) {
        let checkboxElement = document.getElementById('checkBox'+index);
        if(checkboxElement !== undefined && checkboxElement !== null)
            checkboxElement.click();
      }


    let checkBoxSizeDesktop;
    let checkBoxValueSizeDesktop;

    if(props.numOfColumns   ===  2){
        checkBoxSizeDesktop =  checkBoxTwoColumnSize;
        checkBoxValueSizeDesktop    =   checkBoxValueTwoColumnSize;
    }else
    {
        checkBoxSizeDesktop         =  checkBoxOneColumnSize;
        checkBoxValueSizeDesktop    =   checkBoxValueOneColumnSize;
    }

    let answerDisplayArray      =   [];
    var tempSelectedAnswerArray = props.selectedAnswerArray;

    if (props.displayAnswerArr !== undefined && props.displayAnswerArr !== null && props.displayAnswerArr !== "") {
        answerDisplayArray  =   props.displayAnswerArr.map((answerArr, cIndex) => {
            if(answerArr.answer_text !== undefined && answerArr.answer_text !== null && answerArr.answer_text !== ""){
            var checkBox = <input 
            //style= {{position: "absolute", top: "50%"}}
            id={'checkBox'+cIndex}
            onClick={()=>handleClick(answerArr.answer_id.toString(),cIndex)}
             type='checkbox'
              value={answerArr.answer_id.toString()}
              checked ={(tempSelectedAnswerArray !== undefined &&
               tempSelectedAnswerArray.includes(answerArr.answer_id.toString())) ? true : false}/>;
            if(answerArr.isChecked === true )
            {
                checkBox= <input 
                //style= {{position: "absolute", top: "50%"}}
                id={'checkBox'+cIndex}
                checked onClick={()=>handleClick(answerArr.answer_id.toString(),cIndex)} 
                type='checkbox'
                value={answerArr.answer_id.toString()}/>
            }
            var ansTxt = answerArr.answer_text.toString('html',null).replace("<p><br></p>", "").replace("<p><br></p>", "")
            if(props.currentQuestionType === 1){
              ansTxt = MathParserUtil.computeFormula(ansTxt,props.currentVariableMap,answerArr.answer_display_options);
              console.log('ansText',ansTxt);
            }
            //if(props.numOfColumns == 2){
              ansTxt = replaceImageWidth(props, ansTxt)
            //}

            // if(answerArr.hasOwnProperty('is_answer') &&    answerArr.is_answer == 1){
            //     ansTxt = "Answer:" + ansTxt;
            //   }

            let content   =   React.createElement(MathJax,{"math":ansTxt});
            return  ([
                                <Cell key={cIndex+'CheckBox'} style = {{position: "relative"}}
                                  size={checkBoxSizeDesktop} phoneSize={1} tabletSize={2} className='checkbox'>
                                    {checkBox}
                                </Cell>,
                                <Cell onClick={()=>handleClickContent(cIndex)} key={cIndex+'CheckBoxValue'} 
                                    size={checkBoxValueSizeDesktop} phoneSize={3}
                                tabletSize={6}  className='answer-type-radio-button-text'>
                                <label style={{float: "left"}} for={'checkBox'+cIndex}>{content}{ansTxt !== null ? createVideoLinkIframe(ansTxt):''}</label></Cell>
                            ]);
        }
    }
        );

    }


    if (props.displayAnswerArr !== undefined && props.displayAnswerArr.length > 0)
        return <Grid  >
                {answerDisplayArray}
            </Grid>
    else
        return <LoadingSpinner/>
};
export default AnswerTypeCheckbox;
